export default __webpack_public_path__ + "843b0c748731e2af9a506648b5535cc7.svg";